module.exports = __webpack_public_path__ + "img/23.1d5ea9f7.jpg";